/**
 * Base da API para o bundle Vue.
 * O Vue CLI injeta `VUE_APP_*` a partir de `.env` / `.env.production` no build (vai no cliente).
 * Sem variável: fallback local para desenvolvimento.
 *
 * A base pode ser `https://host` ou `https://host/api` (o backend espelha rotas JWT em ambos).
 *
 * Padrão do projeto: usar `flipmemoApiBase` / `flipmemoApiPath` em todas as chamadas (axios ou fetch),
 * incluindo `/auth/google` e `/login`, para produção e desenvolvimento ficarem alinhados.
 */
const kDefaultDevBase = 'http://localhost:8081';

function normalizeBase(url) {
  return String(url || '').trim().replace(/\/$/, '');
}

const fromEnv = normalizeBase(process.env.VUE_APP_API_BASE_URL || '');

/** Base da API (sem barra final). */
export const flipmemoApiBase = fromEnv || kDefaultDevBase;

/**
 * Caminho absoluto na API (suffix com ou sem / inicial).
 */
export function flipmemoApiPath(suffix) {
  const s = suffix.startsWith('/') ? suffix : `/${suffix}`;
  return `${flipmemoApiBase}${s}`;
}

/**
 * URLs para POST …/ai-draft: base configurada e variante com/sem sufixo `/api`
 * (backend espelha rotas JWT em `/` e `/api`; evita 404 por `VUE_APP_API_BASE_URL` errada).
 */
export function flipmemoAiDraftPostUrls(destinationId) {
  const id = encodeURIComponent(String(destinationId));
  const b = normalizeBase(flipmemoApiBase);
  const suffix = `/admin/destinations/${id}/ai-draft`;
  const primary = `${b}${suffix}`;
  const alternate = b.endsWith('/api')
    ? `${normalizeBase(b.replace(/\/api$/, ''))}${suffix}`
    : `${b}/api${suffix}`;
  return primary === alternate ? [primary] : [primary, alternate];
}

/** GET público `…/api/ping` a partir de `flipmemoApiBase` (com ou sem sufixo `/api`). */
export function flipmemoPublicPingUrl() {
  const b = normalizeBase(flipmemoApiBase);
  return b.endsWith('/api') ? `${b}/ping` : `${b}/api/ping`;
}
